import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { APP_INITIALIZER } from "@angular/core";
import { AppConfigService } from './app-config.service';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AppRoutingModule } from "./app.routing";
import { AppComponent } from "./app.component";
import { RouterModule } from "@angular/router";
import { NotFoundComponent } from "./not-found.component";
import { SharedModule } from "./shared/shared.module";
import { CssValidationFormInputDirective } from "./shared/directives/css-validation-form-input.directive";
import { AuthService } from "./core/services/api/auth.service";
import { FileStorageService } from "./core/services/api/file-storage.service";
import { ModuleConfiguration } from "./core/models/module-configuration";
import { ServerErrorInterceptor } from "./core/handler/http-interceptor";
import {
  TimeoutInterceptor,
  DEFAULT_TIMEOUT,
} from "./core/handler/timeout-interceptor";
import { AuthInterceptor } from "./core/handler/auth-interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxLoadingModule } from 'ngx-loading';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { UploadNewInviteComponent } from './modules/documents-grid/components/upload-document/upload-new-invite/upload-new-invite.component';

export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export function initAppConfig(config: AppConfigService) {
  return () => config.load();
}
interface NgxSpinnerConfig {
  type?: string;
}
@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    CssValidationFormInputDirective,
    UploadNewInviteComponent
  ],
  imports: [
    BrowserModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBackgroundColour: 'rgba(0,0,0,0.5)',
      backdropBorderRadius: '3px',
      primaryColour: '#aa0154',
      secondaryColour: '#ffffff',
      tertiaryColour: '#ffffff',
      fullScreenBackdrop: false,
    }),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    RouterModule,
    SharedModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpLoaderFactory,
        deps: [HttpClient],
      },
    })
  ],
  providers: [
  { provide: "IAuthService", useClass: AuthService },
  { provide: "IFileStorageService", useClass: FileStorageService },
  { provide: "IModuleConfiguration", useClass: ModuleConfiguration },

  {
    provide: APP_INITIALIZER,
    useFactory: initAppConfig,
    deps: [AppConfigService],
    multi: true
  },

  {
    provide: HTTP_INTERCEPTORS,
    useClass: ServerErrorInterceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: DEFAULT_TIMEOUT, useValue: 6000000 },
],
  entryComponents: [],
  bootstrap: [AppComponent],
})
export class AppModule {
  availableLng = ["en", "es"];

  //start the translation service
  constructor(private translateService: TranslateService) {
    //defines the default language
    let tmpLng = window.navigator.language;
    let currentLang = localStorage.getItem("language");

    //gets the default browser language
    const currentLng = window.navigator.language.substr(0, 2);
    if (this.availableLng.includes(currentLng)) tmpLng = currentLng;

    if (currentLang) {
      tmpLng = currentLang;
    }

    localStorage.setItem("language", tmpLng);
    translateService.setDefaultLang(tmpLng);
  }
}
